import axios from 'axios';

const dynamicService = {
  /**
   * 获取学会动态列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 当前页码
   * @param {number} params.limit - 每页数量
   * @param {string} params.category - 动态分类
   * @returns {Promise} 返回学会动态列表数据
   */
  getDynamicList(params = {}) {
    return axios.get('/api/dynamics', {
      params,
      timeout: 5000
    });
  },

  /**
   * 获取单个学会动态详情
   * @param {number} id - 学会动态ID
   * @returns {Promise} 返回学会动态详情
   */
  getDynamicById(id) {
    return axios.get(`/api/dynamics/${id}`, {
      timeout: 5000
    });
  },

  /**
   * 获取上一篇和下一篇学会动态
   * @param {number} id - 当前学会动态ID
   * @returns {Promise} 返回上一篇和下一篇学会动态信息
   */
  getAdjacentDynamics(id) {
    return axios.get(`/api/dynamics/${id}/adjacent`, {
      timeout: 5000
    });
  }
};

export default dynamicService; 